export default [
  {
    id: '1',
    label: 'Animal Services',
  },
  {
    id: '2',
    label: 'Auto Sales and Service',
  },
  {
    id: '3',
    label: 'Child/Education Services',
  },
  {
    id: '4',
    label: 'CPG - Food and Beverage',
  },
  {
    id: '5',
    label: 'CPG - Frictionless Payment',
  },
  {
    id: '6',
    label: 'CPG - Household',
  },
  {
    id: '7',
    label: 'CPG - OTC/Beauty',
  },
  {
    id: '8',
    label: 'CPG - Pharmaceuticals',
  },
  {
    id: '9',
    label: 'Dental/Orthodontic Services',
  },
  {
    id: '10',
    label: 'Financial Services',
  },
  {
    id: '11',
    label: 'Fitness Services',
  },
  {
    id: '12',
    label: 'Healthcare Services - Hospitals',
  },
  {
    id: '13',
    label: 'Healthcare Services - Plasma Services',
  },
  {
    id: '14',
    label: 'Healthcare Services - Primary Care',
  },
  {
    id: '15',
    label: 'Healthcare Services - Specialists',
  },
  {
    id: '16',
    label: 'Home & Auto Insurance',
  },
  {
    id: '17',
    label: 'Home Improvement',
  },
  {
    id: '18',
    label: 'Home Furniture and Accessories',
  },
  {
    id: '19',
    label: 'Legal Services',
  },
  {
    id: '20',
    label: 'Media',
  },
  {
    id: '21',
    label: 'Medical Insurance',
  },
  {
    id: '22',
    label: 'Non-Profit',
  },
  {
    id: '23',
    label: 'Personal Services',
  },
  {
    id: '24',
    label: 'Real Estate Services',
  },

  {
    id: '25',
    label: 'Senior Living/Services',
  },
  {
    id: '26',
    label: 'Travel/Leisure/Entertainment',
  },
  {
    id: '27',
    label: 'Wedding Services',
  },
];
